import React, { Component } from "react";
import lang from "../../lang";
import Tooltip from 'rc-tooltip';

class Language extends Component {
	constructor(props) {
		super(props);

		this.state = {
			showSelectPop: false,
			selected: UP.Global.siteLanguage
		};
		
		this.LANG_CONFIG = {
			"zh-CN": {
				option: '简体中文',
				text: '简体中文'
			},
			"zh-TW": {
				option: '繁體中文(台灣)&lrm;',
				text: '繁體中文(台灣)',
			},
			"zh-HK": {
				option: '繁體中文(香港)&lrm;',
				text: '繁體中文(香港)'
			},
			"en-US": {
				option: 'English',
				text: 'English'
			},
			"vi-VN": {
				option: 'Tiếng Việt',
				text: 'Tiếng Việt'
			},
			"ar-EG": {
				option: 'العَرَبِيَّة',
				text: 'العَرَبِيَّة'
			},
			'ja-JP': {
				option: '日本語',
				text: '日本語'
			},
			"ko-KR": {
				option: '한국어',
				text: '한국어'
			},
			'ru-RU': {
				option: "Русский",
				text: "Русский"
			},
			'id-ID': {
				option: "Bahasa Indonesia",
				text: "Bahasa Indonesia"
			},
			// 'sp-SP': {
			// 	option: "ภาษาสเปน",
			// 	text: "ภาษาสเปน"
			// },
			'fr-FR': {
				option: "Français",
				text: "Français"
			},
			'pt-PT': {
				option: "Português",
				text: "Português"
			},
			'ms-MY': {
				option: "Bahasa Melayu",
				text: "Bahasa Melayu"
			},
			'th-TH': {
				option: "ภาษาไทย",
				text: "ภาษาไทย"
			},
			'tr-TR': {
				option: "Türkçe",
				text: "Türkçe"
			},
			'es-ES': {
				option: "España",
				text: "España"
			}
		};
	}

	componentWillMount() {
		if (UP.Global.version == 'CN') {
			$.channel.emit('chooseLanguage', 'zh-CN');
		}
	}

	onSelect(lang, e) {
		e.preventDefault();

		if (lang == this.state.selected) {
			return;
		}

		$.channel.emit('chooseLanguage', lang);
	}


	render() {
		let { showSelectPop, selected } = this.state;
		let langs = UP.Global.languageList;
		let curLanuage = this.LANG_CONFIG[selected].text;
		
		if (UP.Global.version == 'CN') {
			return null;
		}
		
		let $langs = (
			<div className="lang-popup clearfix">
				<ul>
					{
						langs.map((item, index) => {
							let selectedCls = item ==  selected ? 'selected' : '';
							return (
								<li key={index} className={`${item} ${selectedCls}`} onClick={this.onSelect.bind(this, item)}>
									<a href="#" dangerouslySetInnerHTML={{__html: this.LANG_CONFIG[item].option}}></a>
								</li>
							);
						})
					}
				</ul>
			</div>
		)

		return (
			<div className="lang" ref="lang">
				<Tooltip getTooltipContainer={()=>this.refs.lang} overlay={$langs} placement="bottomRight" trigger={['hover']} overlayClassName="header-popover">
                    <div className="lang-select">
						<span className="txt" dangerouslySetInnerHTML={{__html: curLanuage}}></span>
					</div>
                </Tooltip>
			</div>
		);
	}
}

export default Language;



// WEBPACK FOOTER //
// ./js/header/language/index.js